import Calendar from "@/utils/calendar";

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    fixed: "left",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
    width: 150,
    scopedSlots: {
      customRender: "pkgCode",
    },
    fixed: "left",
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    width: 70,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
    customRender: (text, record, index) => {
      return text || "-";
    },
  },
  {
    title: "平台SKU",
    dataIndex: "productSku",
    key: "productSku",
    scopedSlots: {
      customRender: "productSku",
    },
  },
  {
    title: "商品属性",
    dataIndex: "productProp",
    key: "productProp",
    width: 310,
    customRender: (text, record, index) => {
      return text || "-";
    },
  },
  {
    title: "商品数量",
    dataIndex: "amount",
    key: "amount",
    width: 100,
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    width: 100,
  },
  {
    title: "使用数量",
    dataIndex: "useAmount",
    key: "useAmount",
    width: 100,
  },
  {
    title: "剩余数量",
    dataIndex: "remainAmount",
    key: "remainAmount",
    width: 100,
  },
  {
    title: "落单数量",
    dataIndex: "aloneNums",
    key: "aloneNums",
    width: 100,
  },
  {
    title: "组合抵扣数/抵扣数",
    dataIndex: "deductionNums",
    key: "deductionNums",
    // width: 100,
    customRender: (text, record, index) => {
      return `${record.freezeNums || "-"}/${record.deductionNums || "-"}`;
    },
  },
  {
    title: "所在库区",
    dataIndex: "actualRegionName",
    key: "actualRegionName",
  },
  {
    title: "库位",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  {
    title: "体积",
    width: 100,
    dataIndex: "volume",
    key: "volume",
    scopedSlots: {
      customRender: "volume",
    },
  },
  {
    title: "包装尺寸",
    width: 200,
    dataIndex: "size",
    key: "size",
    scopedSlots: {
      customRender: "size",
    },
  },
  {
    title: "商品状态",
    dataIndex: "status",
    key: "status",
    width: 120,
    customRender: (text, record, index) => {
      return {
        1: "初检",
        2: "复检",
        3: "精检",
        4: "成品",
        5: "异常",
        6: "次品",
      }[text];
    },
  },
  {
    title: "批次包类型",
    dataIndex: "pkgType",
    key: "pkgType",
    width: 120,
    customRender: (text, record, index) => {
      return { 1: "正品", 2: "次品", 3: "异常", 4: "异常上报采购" }[text];
    },
  },
  {
    title: "订单编号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
    customRender: (text, record, index) => {
      return text || "-";
    },
  },
  {
    title: "快递单号",
    dataIndex: "expressNo",
    key: "expressNo",
    width: 200,
  },
  {
    title: "入库单号",
    dataIndex: "inboundCode",
    key: "inboundCode",
  },
  {
    title: "附加项",
    dataIndex: "additionalList",
    key: "additionalList",
    width: 100,
    scopedSlots: {
      customRender: "additionalList",
    },
  },
  {
    title: "是否有新商品服务",
    dataIndex: "photographAdditionFlag",
    key: "photographAdditionFlag",
    customRender: (text, record, index) => {
      return ['否','是'][text] || '-'
    },
  },
  {
    title: "是否有尺寸测量服务",
    dataIndex: "sizeMeasureAdditionFlag",
    key: "sizeMeasureAdditionFlag",
    customRender: (text, record, index) => {
      return ['否','是'][text] || '-'
    },
  },
  {
    title: "创建人",
    dataIndex: "createrName",
    key: "createrName",
  },
  {
    title: "入库时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "成品上架时间",
    dataIndex: "shelvedTime",
    key: "shelvedTime",
  },
  // {
  //   title: "所在仓库",
  //   dataIndex: "warehouse",
  //   key: "warehouse",
  //   scopedSlots: {
  //     customRender: "warehouse",
  //   },
  // },
  // {
  //   title: "订单来源",
  //   dataIndex: "systemSource",
  //   key: "systemSource",
  //   customRender: (text, record, index) => {
  //     return { 1: "D2C", 2: "B2B" }[text];
  //   },
  // },
  {
    title: "操作",
    key: "action",
    dataIndex: "id",
    width: 200,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const columnsSon = [
  {
    title: "操作时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "操作人",
    dataIndex: "createrName",
    key: "createrName",
  },
  {
    title: "操作节点",
    dataIndex: "operationType",
    key: "operationType",
    customRender: (text, record, index) => {
      return (
        {
          1: "入库",
          2: "库区调拨",
          3: "拆包",
          4: "上架",
          5: "数量扣减",
          6: "部分移库",
          7: "打包少装",
          8: "库区调拨-驳回"
        }[text] || text
      );
    },
  },
  {
    title: "操作内容",
    dataIndex: "context",
    key: "context",
    customRender: (text, record, index) => {
      return text || "-";
    },
  },
];

export const deductionColumns = [
  {
    title: "发货单号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
  },
  {
    title: "抵扣数量",
    dataIndex: "nums",
    key: "nums",
  },
  {
    title: "抵扣时间",
    dataIndex: "deductionTime",
    key: "deductionTime",
  },
  {
    title: "库龄(天)",
    dataIndex: "inventoryAge",
    key: "inventoryAge",
  },
];
